import { AppAlert, AppButton, AppLoadingSpinner } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AssignCard } from '../components/AssignCard'
import type { InquiryAssignLocal } from '../types'

type AssignListSectionProps = {
  assigns: InquiryAssignLocal[]
  isLoading: boolean
  isError: boolean
  canEdit?: boolean
  onAddAssign: () => void
  onEditAssign: (assign: InquiryAssignLocal) => void
  onDeleteAssign: (id: number) => void
}

export function AssignListSection({
  assigns,
  isLoading,
  isError,
  canEdit = true,
  onAddAssign,
  onEditAssign,
  onDeleteAssign,
}: AssignListSectionProps) {
  return (
    <section className='space-y-3'>
      <h3 className='text-base font-semibold'>アサイン一覧</h3>
      {isLoading ? (
        <div className='flex justify-center py-4'>
          <AppLoadingSpinner text='ローディング中' />
        </div>
      ) : isError ? (
        <AppAlert type='error'>データの取得に失敗しました</AppAlert>
      ) : assigns.length === 0 ? (
        <AppAlert type='info'>データがありません</AppAlert>
      ) : (
        <div className='space-y-3'>
          {assigns.map((assign) => (
            <AssignCard
              key={assign.id}
              assign={assign}
              canEdit={canEdit}
              onEdit={onEditAssign}
              onDelete={onDeleteAssign}
            />
          ))}
        </div>
      )}
      <div className='flex justify-end gap-2'>
        <AppButton variant='outline' size='sm' disabled={!canEdit} onClick={onAddAssign}>
          アサイン追加
        </AppButton>
        {/* TODO: HAMAT連携の実装 */}
        <AppButton variant='outline' size='sm' disabled>
          HAMAT連携
        </AppButton>
      </div>
    </section>
  )
}
